(function () {
  function initCoverflowSlider(container) {
    if (!container || container.dataset.coverflowInitialized === 'true') return;
    var sliderEl = container.querySelector('.productSliderCoverflow');
    if (!sliderEl || typeof Swiper === 'undefined') return;

    var autoplayEnabled = container.dataset.autoplay === 'true';
    var autoplayTime = parseInt(container.dataset.autoplayTime, 10) || 3000;
    var depth = parseInt(container.dataset.depth, 10) || 150;
    var stretch = parseInt(container.dataset.stretch, 10) || -40;
    var rotate = parseInt(container.dataset.rotate, 10) || 0;
    var modifier = parseFloat(container.dataset.modifier) || 1;

    var swiperOptions = {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      speed: 600,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      coverflowEffect: {
        rotate: rotate,
        stretch: stretch,
        depth: depth,
        modifier: modifier,
        slideShadows: false
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev')
      }
    };

    if (autoplayEnabled) {
      swiperOptions.autoplay = { delay: autoplayTime, disableOnInteraction: false };
    }

    var swiperInstance = new Swiper(sliderEl, swiperOptions);
    container.dataset.coverflowInitialized = 'true';

    if (autoplayEnabled) {
      sliderEl.addEventListener('mouseenter', function () {
        swiperInstance.autoplay.stop();
      });
      sliderEl.addEventListener('mouseleave', function () {
        swiperInstance.autoplay.start();
      });
    }
  }

  function initAllCoverflowSliders(scope) {
    (scope || document).querySelectorAll('[data-coverflow-slider]').forEach(initCoverflowSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCoverflowSliders(document);
    });
  } else {
    initAllCoverflowSliders(document);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAllCoverflowSliders(evt.target);
  });
})();
